/**
 * 생성기 링크 입력 — 유튜브·웹사이트 탭에서 자료 링크를 받는다. 순수 UI 다.
 * Figma SourceField youtube·web — 40 높이 입력칸 옆에 「추가」 버튼(md, 간격 6)이 따로 선다.
 */
import { TextField } from '@zep-us/zus';
import { Button } from '@zep-us/zus/button';
import { Blue500 } from '@zep-us/zus/tokens';
import { GlobeFillIcon, YoutubeColorIcon } from '@zep-us/zus-icons';
import { type AiGenerateDockLinkSourceType } from '../consts/aiGenerateDock.const';
import { type AiGenerateDockCopy } from '../types/aiGenerateDock.types';
export const AiGenerateDockLinkInput = ({
  sourceType,
  copy,
  value,
  onChange,
  onSubmit
}: {
  sourceType: AiGenerateDockLinkSourceType;
  copy: AiGenerateDockCopy;
  value: string;
  onChange: (url: string) => void;
  onSubmit: () => void;
}) => <div className="flex w-full gap-2xs" data-sentry-component="AiGenerateDockLinkInput" data-sentry-source-file="AiGenerateDockLinkInput.tsx">
    <TextField.Root required={false} className="min-w-0 flex-1" data-sentry-element="unknown" data-sentry-source-file="AiGenerateDockLinkInput.tsx">
      <TextField.Input type="url" inputMode="url" data-testid="ai-generate-dock-link-input" aria-label={copy.linkPlaceholder[sourceType]} placeholder={copy.linkPlaceholder[sourceType]} value={value} onChange={event => onChange(event.target.value)} onKeyDown={event => {
      if (event.key === 'Enter' && !event.nativeEvent.isComposing) {
        event.preventDefault();
        onSubmit();
      }
    }} className="placeholder:text-disabled" wrapperClassName="h-[40px] py-xs" leftSlot={sourceType === 'youtube' ? <YoutubeColorIcon size="sm" aria-hidden /> : <GlobeFillIcon size="sm" fill={Blue500} aria-hidden />} data-sentry-element="unknown" data-sentry-source-file="AiGenerateDockLinkInput.tsx" />
    </TextField.Root>
    <Button size="md" variant="outlined" intent="neutral" className="shrink-0" disabled={!value.trim()} onClick={onSubmit} data-sentry-element="Button" data-sentry-source-file="AiGenerateDockLinkInput.tsx">
      {copy.linkSubmit}
    </Button>
  </div>;